export enum DeployType {
    Deploy = "Deploy",
    Maintenance = "Maintenance",
}
